// Turns the serialized eZee/OTA comment (which carries {{P}} paragraph + <br> line markers from
// BookingInfoSerializer#sanitize_comment) into plain multi-line text for display.
export const cleanComment = (raw) =>
  (raw || "")
    .replace(/\{\{P\}\}/g, "\n")
    .replace(/<br\s*\/?>/gi, "\n")
    .trim();
